import Util from "@/helper/Utility"

export const AddToBagModel = function () {
    this.sideCampaignJson = ""
    this.remark = ""
    this.qty = 1
    this.mode = "add"
    this.countQuantity = true
    this.campaignId = ""
    this.info1 = ""

    // Tracking Label
    this.trakingCampaign = ""
    this.trackingSide = ""
    this.trackingSideOther = ""
    this.trackingIngredient = ""
    this.trackingAppetizers = ""
}
/**
 * params from ProductOptionBuilder.vue
 * @param {import("@/core/Campaign/model/CampaignModel").default} campaign
 * @param {import("@vue/reactivity").UnwrapNestedRefs} campaignOptions
 * @param {import("@vue/reactivity").UnwrapNestedRefs} optionStates
 */
AddToBagModel.prototype.fromOptionsBuilder = function (campaign, campaignOptions, optionStates) {
    // console.log(optionStates);
    let sideCampaignJsonArr = []
    let trackingSideArr = [];
    let trackingSideOtherArr = [];
    let ingredientsTrackingArr = []
    let appetizersTrackingArr = []
    let multiIngredientsTrackingArr = []

    console.log("optionStates", optionStates)

    // set campaign id
    if (campaignOptions.meats != null) {
        this.campaignId = optionStates.meats.campaignId
        this.trakingCampaign =  optionStates.meats
    } else {
        // use main campaign
        this.campaignId = campaign.id
        this.trakingCampaign = campaign
    }

    // set side campaign json
    // others
    if (campaignOptions.others.length > 0) {
        for (const other of optionStates.others) {
            // check type
            if (other.type == "radio") {
                // type: radio group
                if (other.data != null) {
                    /**@type {import("@/core/Campaign/model/CampaignModel").default} */
                    let selectedCampaign = other.data

                    sideCampaignJsonArr.push(selectedCampaign.id)

                    trackingSideOtherArr.push(selectedCampaign.name)
                }
            }
        }
    }

    // add-on
    if (campaignOptions.addOn.length > 0) {
        let filterHasQty = optionStates.addOn.filter(x => x.qty > 0)
        for (const item of filterHasQty) {
            for (let i = 0; i < item.qty; i++) {
                sideCampaignJsonArr.push(item.data.id)

                let tracking_side = {
                    qty: item.qty,
                    addon: item.data
                };
                trackingSideArr.push(tracking_side)
            }
        }
    }
    // add-ons
    if (campaignOptions.addOns != null && campaignOptions.addOns.length > 0) {
        for(const item of optionStates.addOns){
            let filterHasQty = item ? item.filter(x => x.qty > 0) : []
            if(filterHasQty){
                for (const item of filterHasQty) {
                    for (let i = 0; i < item.qty; i++) {
                        sideCampaignJsonArr.push(item.data.id)

                        let tracking_side = {
                            qty: item.qty,
                            addon: item.data
                        };
                        trackingSideArr.push(tracking_side)
                    }
                }
            }
        }
    }

    this.trackingSide = ""
    this.trackingSide = trackingSideArr;
    this.trackingSideOther = ""
    this.trackingSideOther = trackingSideOtherArr;

    // remarks || multi ingredients
    if (campaignOptions.multiIngredients != null && campaignOptions.multiIngredients.length > 0) {
        for(let i = 0; i < campaignOptions.multiIngredients; i++){
            for(const item of campaignOptions.multiIngredients[i]){
                let existsIdx = campaignOptions.multiIngredients[i].findIndex(x => x.id == item.id)
                if (existsIdx >= 0) {
                    sideCampaignJsonArr.push(item.id)
                    multiIngredientsTrackingArr[i].push({
                        id: item.id,
                        name: item.name,
                        name_en: item.name_en
                    })
                }
            }
        }
    }
    this.multiIngredientsTrackingArr = ""
    this.multiIngredientsTrackingArr = multiIngredientsTrackingArr

    // set ingredients
    if (campaignOptions.ingredients != null && campaignOptions.ingredients.length > 0) {
        for (const item of campaignOptions.ingredients) {
            let existsIdx = optionStates.ingredients.findIndex(x => x.id == item.id)
            if (existsIdx >= 0) {
                sideCampaignJsonArr.push(item.id)
                ingredientsTrackingArr.push({
                    id: item.id,
                    name: item.name,
                    name_en: item.name_en
                })
            }
        }
    }
    this.trackingIngredient = ""
    this.trackingIngredient = ingredientsTrackingArr

    // set appetizers
    if (campaignOptions.appetizers != null && campaignOptions.appetizers.length > 0) {
        for(let i = 0; i < campaignOptions.appetizers.length; i++){
            if(campaignOptions.appetizers[i].maximum_item !== undefined){
                if(optionStates.appetizers[i].list.length > 0){
                    for(const item of optionStates.appetizers[i].list){
                        sideCampaignJsonArr.push(item.id)
                        appetizersTrackingArr.push({
                            id: item.id,
                            name: item.name,
                            name_en: item.name_en
                        })
                    }
                }
            }
            else {
                let filterHasQty = optionStates.appetizers[i].filter(x => x.qty > 0)
                if(filterHasQty){
                    for (const item of filterHasQty) {
                        for (let i = 0; i < item.qty; i++) {
                            sideCampaignJsonArr.push(item.data.id)

                            let appetizers_tracking_arr = {
                                qty: item.qty,
                                appetizers: item.data
                            };
                            appetizersTrackingArr.push(appetizers_tracking_arr)
                        }
                    }
                }
            }
        }
    }
    this.trackingAppetizers = ""
    this.trackingAppetizers = appetizersTrackingArr

    // set side campaign json
    this.sideCampaignJson = JSON.stringify(sideCampaignJsonArr)

    // set remark
    this.remark = ""
    let resultRemark = JSON.stringify(new Remark(campaignOptions, optionStates))
    this.remark = resultRemark

    // set qty
    this.qty = optionStates.quantity.qty

    this.info1 = optionStates.subScription ? optionStates.subScription.Key : ''

    return this
}

AddToBagModel.prototype.getOptionLabel = function () {
    return {
        trakingCampaign:this.trakingCampaign,
        trackingSide:this.trackingSide,
        trackingSideOther:this.trackingSideOther,
        ingredients: this.trackingIngredient,
        qty: this.qty,
    }
}

AddToBagModel.prototype.getParams = function () {
    return {
        sideCampaignJson: this.sideCampaignJson,
        remark: this.remark,
        qty: this.qty,
        mode: this.mode,
        countQuantity: this.countQuantity,
        campaignId: this.campaignId,
        info1: this.info1
    }
}

export class Remark {
    constructor(dataCampaignOptions, dataOptionStates) {
        this.others = []
        this.addons = []
        this.remarks = []
        this.appetizers = []

        if(dataOptionStates.others.length > 0){
            for (let i of dataOptionStates.others) {
                let item = new OthersModel(i)
                this.others.push(item)
            }
        }
        if(dataCampaignOptions.addOns != null && dataCampaignOptions.addOns.length > 0) {
            for (let i = 0; i < dataCampaignOptions.addOns.length; i++) {
                let item = new AddonsMainModel(i, dataCampaignOptions.addOns[i], dataOptionStates.addOns[i])
                if(!Util.isEmptyObject(item.items)){
                    this.addons.push(item)
                }
            }
        }
        else {
            let index = 0
            let item = new AddonsMainModel(index, dataCampaignOptions.addOn, dataOptionStates.addOn)
            if(!Util.isEmptyObject(item.items)){
                this.addons.push(item)
            }
        }
        if(dataOptionStates.multiIngredients != null && dataOptionStates.multiIngredients.length > 1){
            for (let i = 0; i < dataCampaignOptions.multiIngredients.length; i++) {
                let item = new MultiIngredientsMainModel(i, dataCampaignOptions.addOns[i], dataOptionStates.multiIngredients[i].data)
                if(!Util.isEmptyObject(item.items)){
                    this.remarks.push(item)
                }
            }
        } else {
            if (dataOptionStates.ingredients[0]) {
                let index = 0
                let item = new IngredientsMainModel(index, dataOptionStates.ingredients[0].data)
                if(!Util.isEmptyObject(item.items)){
                    this.remarks.push(item)
                }
            }
        }
        if(dataOptionStates.appetizers.length > 0) {
            for (let i = 0; i < dataCampaignOptions.appetizers.length; i++) {
                let item = new AppetizersMainModel(i, dataCampaignOptions.appetizers[i], dataOptionStates.appetizers[i])
                if(!Util.isEmptyObject(item.items)){
                    this.appetizers.push(item)
                }
            }
        }
    }
}

export class OthersModel {
    constructor(data) {
        this.campaign_id = data.data.id
        this.name = data.data.name
        this.name_en = this.setNameEn(data)
        this.quantity = 1
        this.priceperunit = data.data.pricePerUnit
        this.total_amount = data.data.pricePerUnit * this.quantity
    }

    setNameEn(data){
        if(data?.data?.name_en) return data.data.name_en
        return data.data.name
    }
}

export class AddonsMainModel {
    constructor(index, data, dataOption){
        this.index = index
        this.header = data.header
        this.header_en = data.header_en
        this.items = []
        if(dataOption){
            for (let i = 0; i < dataOption.length; i++) {
                let item = new AddonsModel(dataOption[i])
                if(item.quantity > 0){
                    this.items.push(item)
                }
            }
        }
    }
}

export class AddonsModel {
    constructor(data) {
        this.campaign_id = data.data.id
        this.name = data.data.name
        this.name_en = this.setNameEn(data)
        this.quantity = data.qty
        this.priceperunit = data.data.pricePerUnit
        this.total_amount = data.data.pricePerUnit * this.quantity
    }

    setNameEn(data){
        if(data?.data?.name_en) return data.data.name_en
        return data.data.name
    }
}

export class IngredientsMainModel {
    constructor(index, dataOption){
        this.index = index
        this.items = []
        for (let i = 0; i < dataOption.length; i++) {
            let item = new IngredientsModel(dataOption[i])
            this.items.push(item)
        }

    }
}

export class IngredientsModel {
    constructor(data) {
        this.id = data.id
        this.name = data.name
        this.name_en = data.name_en
    }
}

export class MultiIngredientsMainModel {
    constructor(index, data, dataOption){
        this.index = index
        this.header = data.header
        this.header_en = data.header_en
        this.items = []
        for (let i = 0; i < dataOption.length; i++) {
            let item = new MultiIngredientsModel(dataOption[i])
            this.items.push(item)
        }

    }
}

export class MultiIngredientsModel {
    constructor(data) {
        this.id = data.id
        this.name = data.name
        this.name_en = data.name_en
    }
}

export class AppetizersMainModel {
    constructor(index, data, dataOption){
        this.index = index
        this.header = data.header
        this.header_en = data.header_en
        this.items = []
        if(dataOption && dataOption.length > 0){
            for (let i of dataOption) {
                let item = new AppetizersModel(i)
                if(item.quantity > 0){
                    this.items.push(item)
                }
            }
        }else if(dataOption && dataOption?.list?.length > 0) {
            for(const i of dataOption.list){
                let item = new CheckboxModel(i)
                this.items.push(item)
            }
        }
    }
}

export class CheckboxModel {
    constructor(data) {
        this.campaign_id = data.id
        this.name = data.name
        this.name_en = this.setNameEn(data)
        this.quantity = 1
        this.priceperunit = data.pricePerUnit
        this.total_amount = data.pricePerUnit * this.quantity
    }

    setNameEn(data){
        if(data.name_en) return data.name
        return data.name
    }
}

export class AppetizersModel {
    constructor(data) {
        this.campaign_id = data.data.id
        this.name = data.data.name
        this.name_en = this.setNameEn(data)
        this.quantity = data.qty
        this.priceperunit = data.data.pricePerUnit
        this.total_amount = data.data.pricePerUnit * this.quantity
    }

    setNameEn(data){
        if(data?.data?.name_en) return data.data.name_en
        return data.data.name
    }
}

export default AddToBagModel
